// extracted by mini-css-extract-plugin
export default {"filterItem":"filterItem--6a52de9"};